import { useId } from "react";
import { Button } from "@/shared/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shared/ui/dialog";
import type { Company } from "@/services/api/companies";

interface CompanyStatusDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  company: Company | null;
  onConfirm: () => void;
  isLoading: boolean;
}

export function CompanyStatusDialog({
  open,
  onOpenChange,
  company,
  onConfirm,
  isLoading,
}: CompanyStatusDialogProps) {
  const descriptionId = useId();

  if (!company) return null;

  const isActivating = !company.isActive;
  const action = isActivating ? "activate" : "deactivate";
  const actionCapitalized = isActivating ? "Activate" : "Deactivate";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-[425px]"
        aria-describedby={descriptionId}
      >
        <DialogHeader>
          <DialogTitle>{actionCapitalized} Company</DialogTitle>
          <DialogDescription>
            Are you sure you want to {action} "{company.name}"?
            {!isActivating && (
              <> Deactivated companies will no longer be tracked.</>
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button type="submit" onClick={onConfirm} disabled={isLoading}>
            {isLoading
              ? `${actionCapitalized.slice(0, -1)}ing...`
              : actionCapitalized}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
